import { DsFormTemplateFieldType } from '../types/ds-form-template-field.type';
import { DsFormSection } from '../classes/forms-fields/ds-form-section.class';
import { DsFormBoolean } from '../classes/forms-fields/ds-form-boolean.class';
import { DsFormText } from '../classes/forms-fields/ds-form-text.class';
import { DsFormTextArea } from '../classes/forms-fields/ds-form-textarea.class';
import { DsFormNumber } from '../classes/forms-fields/ds-form-number.class';
import { DsFormDate } from '../classes/forms-fields/ds-form-date.class';
import { DsFormDateTime } from '../classes/forms-fields/ds-form-datetime.class';
import { DsFormRadio } from '../classes/forms-fields/ds-form-radio.class';
import { DsFormListBox } from '../classes/forms-fields/ds-form-listbox.class';
import { DsFormChoice } from '../classes/forms-fields/ds-form-choice.class';
import { DsFormSignature } from '../classes/forms-fields/ds-form-signature.class';
import { DsFormSectionInterface } from '../interfaces/form-fields/ds-form-section.interface';
import { DsFormOptionsFieldInterface } from '../interfaces/form-fields/ds-form-options-field.interface';
import { DsFormTextInterface } from '../interfaces/form-fields/ds-form-text.interface';
import { DsFormMetadataFieldInterface } from '../interfaces/form-fields/ds-form-metadata-field.interface';
import { DsFormDateInterface } from '../interfaces/form-fields/ds-form-date.interface';
import { DsFormTypeEnum } from '../enums/ds-forms.enum';
import { DsFormTemplateFieldInterfaceType } from '../types/ds-form-template-field.interface.type';
import { DsFormStaticTableInterface } from '../interfaces/form-fields/ds-form-statictable.interface';
import { DsFormStaticTable } from '../classes/forms-fields/ds-form-statictable.class';
import { DsFormDynamicTable } from '../classes/forms-fields/ds-form-dynamictable.class';
import { DsFormDynamicTableInterface } from '../interfaces/form-fields/ds-form-dynamictable.interface';
import { DsFormPhoto } from '../classes/forms-fields/ds-form-photo.class';
import { DsFormDocument } from '../classes/forms-fields/ds-form-document.class';

/**
 * Returns the corresponding instanciated class instance according to the field type.
 *
 * @param input A form template field that has not been instanciated
 * @returns DsFormTemplateFieldType
 */
export function dsFormsGetTemplateField(input: DsFormTemplateFieldInterfaceType): DsFormTemplateFieldType {
  switch (input.type) {
    case DsFormTypeEnum.SECTION:
      return new DsFormSection(input as DsFormSectionInterface);
    case DsFormTypeEnum.BOOLEAN:
      return new DsFormBoolean(input as DsFormOptionsFieldInterface);
    case DsFormTypeEnum.TEXT:
      return new DsFormText(input as DsFormTextInterface);
    case DsFormTypeEnum.TEXTAREA:
      return new DsFormTextArea(input as DsFormMetadataFieldInterface);
    case DsFormTypeEnum.NUMBER:
      return new DsFormNumber(input as DsFormMetadataFieldInterface);
    case DsFormTypeEnum.DATE:
      return new DsFormDate(input as DsFormDateInterface);
    case DsFormTypeEnum.DATETIME:
      return new DsFormDateTime(input as DsFormMetadataFieldInterface);
    case DsFormTypeEnum.RADIO:
      return new DsFormRadio(input as DsFormOptionsFieldInterface);
    case DsFormTypeEnum.LISTBOX:
      return new DsFormListBox(input as DsFormOptionsFieldInterface);
    case DsFormTypeEnum.CHOICE:
      return new DsFormChoice(input as DsFormMetadataFieldInterface);
    case DsFormTypeEnum.SIGNATURE:
      return new DsFormSignature(input as DsFormMetadataFieldInterface);
    case DsFormTypeEnum.STATIC_TABLE:
      return new DsFormStaticTable(input as DsFormStaticTableInterface);
    case DsFormTypeEnum.DYNAMIC_TABLE:
      return new DsFormDynamicTable(input as DsFormDynamicTableInterface);
    case DsFormTypeEnum.PHOTO:
      return new DsFormPhoto(input as DsFormMetadataFieldInterface);
    case DsFormTypeEnum.DOCUMENT:
      return new DsFormDocument(input as DsFormMetadataFieldInterface);
    default:
      return null;
  }
}
